import * as React from 'react';

/*
 * Chrome icon set, lifted from the approved concept
 * (docs/design-brief/chrome-concept.html): 14px stroke-2 outline,
 * color comes from the parent (icon-secondary at rest).
 */

function I({
    children,
    size = 14,
    strokeWidth = 2,
}: {
    children: React.ReactNode;
    size?: number;
    strokeWidth?: number;
}) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            aria-hidden="true"
        >
            {children}
        </svg>
    );
}

export const IconHome = () => (
    <I>
        <path d="m3 10 9-7 9 7v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z" />
    </I>
);
export const IconActivations = () => (
    <I>
        <rect x="3" y="4" width="18" height="17" rx="2" />
        <path d="M3 9h18M8 2v4M16 2v4" />
    </I>
);
export const IconDevices = () => (
    <I>
        <rect x="2" y="4" width="20" height="13" rx="2" />
        <path d="M8 21h8M12 17v4" />
    </I>
);
export const IconPipeline = () => (
    <I>
        <path d="M3 12h4l3-8 4 16 3-8h4" />
    </I>
);
export const IconTasks = () => (
    <I>
        <path d="m5 12 4 4L19 6" />
    </I>
);
export const IconDesign = () => (
    <I>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 3a9 9 0 0 0 0 18c1.5 0 2-1 2-2v-2a2 2 0 0 1 2-2h2c1 0 2-.5 2-2" />
    </I>
);
export const IconStaff = () => (
    <I>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    </I>
);
export const IconGear = () => (
    <I>
        <path d="M14.7 6.3a5 5 0 0 0-7 7L3 18v3h3l4.7-4.7a5 5 0 0 0 7-7L14 13l-3-3Z" />
    </I>
);
export const IconVenues = () => (
    <I>
        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
        <circle cx="12" cy="10" r="3" />
    </I>
);
export const IconContacts = () => (
    <I>
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <circle cx="9" cy="10" r="2" />
        <path d="M15 8h4M15 12h4M5 18c.8-2 2.5-3 4-3s3.2 1 4 3" />
    </I>
);
export const IconFavorites = () => (
    <I>
        <path d="m12 3 2.6 5.6 5.9.7-4.4 4.1 1.2 5.9L12 16.4l-5.3 2.9 1.2-5.9L3.5 9.3l5.9-.7Z" />
    </I>
);
export const IconAssets = () => (
    <I>
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="9" cy="9" r="2" />
        <path d="m21 15-4-4-8 8" />
    </I>
);
export const IconSoftware = () => (
    <I>
        <path d="M12 3v12m0 0 4-4m-4 4-4-4" />
        <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" />
    </I>
);

/* event scope */
export const IconOverview = () => (
    <I>
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="7" height="7" rx="1" />
    </I>
);
export const IconGallery = () => (
    <I>
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="9" cy="9" r="2" />
        <path d="m21 15-4-4-8 8" />
    </I>
);
export const IconCapture = () => (
    <I>
        <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3Z" />
        <circle cx="12" cy="13" r="3.5" />
    </I>
);
export const IconMedia = () => (
    <I>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="m3 15 5-5 4 4 3-3 6 6" />
    </I>
);
export const IconSharing = () => (
    <I>
        <path d="m22 2-7 20-4-9-9-4Z" />
        <path d="M22 2 11 13" />
    </I>
);
export const IconInsights = () => (
    <I>
        <path d="M3 20V10M10 20V4M17 20v-7" />
    </I>
);
export const IconIntegrations = () => (
    <I>
        <path d="M9 17H6a4 4 0 0 1 0-8 5 5 0 0 1 9.6-1.5A4.5 4.5 0 0 1 17 17h-2" />
        <path d="M12 12v9m0-9 3 3m-3-3-3 3" />
    </I>
);
export const IconPayments = () => (
    <I>
        <rect x="2" y="5" width="20" height="14" rx="2" />
        <path d="M2 10h20" />
    </I>
);

/* controls */
export const IconSearch = ({ size = 14 }: { size?: number }) => (
    <I size={size}>
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-3.5-3.5" />
    </I>
);
export const IconMenu = () => (
    <I size={16}>
        <path d="M4 7h16M4 12h16M4 17h16" />
    </I>
);
export const IconClose = ({ size = 16 }: { size?: number }) => (
    <I size={size}>
        <path d="M6 6l12 12M18 6 6 18" />
    </I>
);
export const IconBack = ({ size = 12 }: { size?: number }) => (
    <I size={size}>
        <path d="M19 12H5m0 0 6 6m-6-6 6-6" />
    </I>
);
export const IconUpDown = () => (
    <svg
        width="10"
        height="10"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        aria-hidden="true"
    >
        <path d="m7 15 5 5 5-5M7 9l5-5 5 5" />
    </svg>
);
export const IconDots = () => (
    <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden="true"
    >
        <circle cx="5" cy="12" r="1.6" />
        <circle cx="12" cy="12" r="1.6" />
        <circle cx="19" cy="12" r="1.6" />
    </svg>
);

export const AREA_ICONS: Record<string, React.ComponentType> = {
    home: IconHome,
    activations: IconActivations,
    devices: IconDevices,
    pipeline: IconPipeline,
    tasks: IconTasks,
    design: IconDesign,
    staff: IconStaff,
    gear: IconGear,
    venues: IconVenues,
    contacts: IconContacts,
    favorites: IconFavorites,
    assets: IconAssets,
    software: IconSoftware,
    overview: IconOverview,
    production: IconPipeline,
    gallery: IconGallery,
    capture: IconCapture,
    media: IconMedia,
    sharing: IconSharing,
    insights: IconInsights,
    integrations: IconIntegrations,
    payments: IconPayments,
};
